<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4 class="mb-0">ยืนยันรหัส OTP</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div class="text-gray-2">
        ยืนยันรหัส OTP สำหรับหมายเลข {{ selectedItem.telephone }}
      </div>
      <div>
        <InputText
          :textFloat="`Ref.${refCode}`"
          v-model="otpCode"
          class="mb-2"
          placeholder="OTP"
          type="text"
        />
      </div>
      <div class="mt-3">
        <b-button
          class="btn-modal radius-btn"
          block
          variant="secondary"
          @click="verifyOTP"
          >ยืนยัน</b-button
        >
        <b-row no-gutters class="mt-2">
          <b-col class="pr-2">
            <b-button
              class="btn-modal radius-btn"
              block
              variant="outline"
              @click="$refs.modalConfirmOther.show()"
              >ยืนยันด้วยวิธีอื่น</b-button
            ></b-col
          >
          <b-col class="pl-2"
            ><b-button
              class="btn-modal radius-btn"
              block
              variant="outline"
              :disabled="disabledOTP"
              @click="sendOTP"
              >ขอ OTP ใหม่
              {{ countDown <= 10 ? `(${countDown})`: '' }}</b-button
            ></b-col
          >
        </b-row>
      </div>
    </b-modal>
    <ModalConfirmOther
      ref="modalConfirmOther"
      @confirm="hide"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import ModalConfirmOther from "./ModalConfirmOther.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    InputText,
    ModalConfirmOther,
  },
  data() {
    return {
      showModal: false,
      refCode: "",
      disabledOTP: true,
      countDown: 11,
      myInterval: null,
      otpCode: ""
    };
  },
  computed: {
    ...mapGetters({ selectedItem: "getSelectedItem" }),
  },
  watch: {
    countDown(newValue, oldValue) {
      if (newValue == 0) {
        clearInterval(this.myInterval);
        this.countDown = 11;
        this.disabledOTP = false;
      }
    },
  },
  methods: {
    async show() {
      await this.sendOTP();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    countDownTimer() {
      this.countDown -= 1;
    },
    async sendOTP() {
      let body = {
        telephone: this.selectedItem.telephone,
        redeemOrderId: this.selectedItem.redeem_order_id,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/SendOTP`, body)
        .then(async (data) => {
          if (data.result == 1) {
            this.refCode = data.detail;

            this.disabledOTP = true;
            this.myInterval = setInterval(() => {
              this.countDownTimer();
            }, 1000);
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
    async verifyOTP() {
      let body = {
        telephone: this.selectedItem.telephone,
        redeemOrderId: this.selectedItem.redeem_order_id,
        refCode: this.refCode,
        OTP: this.otpCode,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/VerifyOTP`, body)
        .then(async (data) => {
          if (data.result == 1) {
            await this.confirm();
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
    async confirm() {
      let body = {
        new_status: 5,
        redeem_order_id: this.selectedItem.redeem_order_id,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/update_redeem_order_status`, body)
        .then(async (data) => {
          if (data.result == 1) {
            this.disabled = true;
            this.successAlert();
            this.$router
              .push({ path: `/redeem/history/${this.selectedItem.member_id}` })
              .catch(() => {});
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  color: var(--primary-color);
  padding: 15px !important;
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>
